const BLACK = '#000000'
const WHITE = '#FFFFFF'

type HeaderPortal = {
  storefront_header_background_color?: string | null
  client?: {
    admin_header_background_color?: string | null
  } | null
}

type HeaderColorOverride = {
  backgroundColor: string
  foregroundColor: string
}

const parseHexColor = (color: string): [number, number, number] | null => {
  const match = /^#([0-9A-F]{6})$/i.exec(color)
  if (!match) return null

  const channels = [0, 2, 4].map(offset => Number.parseInt(match[1].slice(offset, offset + 2), 16) / 255)
  return [channels[0], channels[1], channels[2]]
}

const linearizeChannel = (channel: number) => {
  return channel <= 0.04045 ? channel / 12.92 : ((channel + 0.055) / 1.055) ** 2.4
}

const relativeLuminance = (color: string) => {
  const channels = parseHexColor(color)
  if (!channels) return null

  const [red, green, blue] = channels.map(linearizeChannel)
  return 0.2126 * red + 0.7152 * green + 0.0722 * blue
}

export const getAccessibleHeaderForeground = (backgroundColor: string) => {
  const backgroundLuminance = relativeLuminance(backgroundColor)
  if (backgroundLuminance === null) return null

  const blackContrast = (backgroundLuminance + 0.05) / 0.05
  const whiteContrast = 1.05 / (backgroundLuminance + 0.05)
  return blackContrast >= whiteContrast ? BLACK : WHITE
}

export const getHeaderColorOverride = ({
  portal,
  isAdminUserPath
}: {
  portal?: HeaderPortal | null
  isAdminUserPath: boolean
}): HeaderColorOverride | null => {
  // Null intentionally emits no scoped header-color override.
  const backgroundColor = isAdminUserPath
    ? portal?.client?.admin_header_background_color
    : portal?.storefront_header_background_color
  if (!backgroundColor) return null

  const foregroundColor = getAccessibleHeaderForeground(backgroundColor)
  if (!foregroundColor) return null

  return { backgroundColor, foregroundColor }
}
